var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgArrowLeftDark(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.56945 19.1664C9.37945 19.1664 9.18945 19.0964 9.03945 18.9464L2.96945 12.8764C2.67945 12.5864 2.67945 12.1064 2.96945 11.8164L9.03945 5.74643C9.32945 5.45643 9.80945 5.45643 10.0995 5.74643C10.3895 6.03643 10.3895 6.51643 10.0995 6.80643L4.55945 12.3464L10.0995 17.8864C10.3895 18.1764 10.3895 18.6564 10.0995 18.9464C9.95945 19.0964 9.75945 19.1664 9.56945 19.1664Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.4999 13.0964H3.66992C3.25992 13.0964 2.91992 12.7564 2.91992 12.3464C2.91992 11.9364 3.25992 11.5964 3.66992 11.5964H20.4999C20.9099 11.5964 21.2499 11.9364 21.2499 12.3464C21.2499 12.7564 20.9099 13.0964 20.4999 13.0964Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowLeftDark);
export default __webpack_public_path__ + "static/media/arrow-left_dark.6d6538226aeec69e485ee51f9a3149aa.svg";
export { ForwardRef as ReactComponent };